// extracted by mini-css-extract-plugin
var _1 = "EmailProfileMessageReplyForm-moduleEmailProfileMessageReplyForm__CHbOK";
var _2 = "EmailProfileMessageReplyForm-modulecontent__F_tnf";
var _3 = "EmailProfileMessageReplyForm-moduleformBody__VCVjE EmailCreationForm-moduleformBody__hZad9";
export { _1 as "EmailProfileMessageReplyForm", _2 as "content", _3 as "formBody" }
